import axios from 'axios';

import {
    ADD_COLLECTION,
    ADD_CONTRACT,
    ADD_PROCESS,
    ADD_PROCESS_CONTRACT,
    CONTRACT_URL,
    DO_PROCESS_ACTION,
    GET_ASSET,
    GET_ASSET_BINDINGS_BY_QUERY,
    GET_ASSETS_BY_QUERY,
    GET_COLLECTION_DETAILS,
    GET_COLLECTIONS_URL,
    GET_CONTRACT_DETAILS,
    GET_PROCESS_CONTRACT,
    GET_PROCESS_CONTRACT_STATUS,
    GET_PROCESS_DETAILS,
    GET_PROCESS_LIST,
    GET_SERVER_CONFIG,
    GET_TOKEN_BINDINGS,
    UPDATE_EXTENDED_ASSET,
    UPDATE_PROCESS_CONTRACT
} from '../consts';
import AuthCookies from '../components/auth-cookies';
import CollectionModel from "../models/collection";
import ResponseModel from "../models/ResponseModel";
import ContractModel from "../models/contract";
import ProcessContractModel from "../models/process-contract";
import {getSelectedEnv} from "../common";
import IAssetFilter from "../models/assets-filter";

export default class SandraJsAPI {

    private static getProdAuthHeader() {
        const {getAuthCookie} = AuthCookies();
        return {
            withCredentials: false,
            headers: {
                'X-Server': "prod_balor",
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthCookie()}`
            }
        };
    }

    private static getAuthHeader() {
        const {getAuthCookie} = AuthCookies();
        return {
            withCredentials: false,
            headers: {
                'X-Server': getSelectedEnv(),
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthCookie()}`
            }
        };
    }

    public static async getCollections(): Promise<ResponseModel> {
        try {
            const response = await axios.get(GET_COLLECTIONS_URL, SandraJsAPI.getAuthHeader());
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async addCollection(collection: CollectionModel) {
        try {
            const data = {
                collection
            };
            const response = await axios.post(
                ADD_COLLECTION,
                data,
                SandraJsAPI.getAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getCollectionDetailsAsync(collectionId: string): Promise<ResponseModel> {
        try {
            const response = await axios.get(GET_COLLECTION_DETAILS + collectionId + "?loadContracts=true", SandraJsAPI.getAuthHeader());
            let data = response.data;
            let collSubjId = data.data?.collection?.subjectId

            if (data?.data?.contracts) {
                let contracts = [...data.data.contracts];
                data.data.contracts = contracts.map(c => {
                    let s = c.joined.find((j: any) => {
                        if ("contractStandard" in j) {
                            return true;
                        } else return false;
                    });
                    let col = c.joined.find((j: any) => {
                        if ("inCollection" in j) {
                            if (String(j.inCollection?.subjectId) == String(collSubjId))
                                return true;
                            else return false;
                        } else return false;
                    });
                    let standard = s?.contractStandard?.class_name;
                    if (standard) standard = standard.replace("CsCannon\\Blockchains\\Contracts\\", "");
                    let cont = {
                        collections: [],
                        token: {
                            tokenId: '',
                            tokenUrl: '',
                        },
                        blockchain: c.brothers?.onBlockchain,
                        standard: standard,
                        address: c.id,
                        assetKeyId: col?.inCollection?.refs?.assetKeyId,
                        baseTokenUrl: col?.inCollection?.refs?.baseTokenUrl,
                        metadataType: c.metadataType
                    }
                    return cont;
                })
            }

            return data;

        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async addContract(contract: ContractModel, collection: CollectionModel) {
        try {

            const data = {
                contract,
                collectionId: collection.collectionId
            };
            const response = await axios.post(
                ADD_CONTRACT,
                data,
                SandraJsAPI.getAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async updateAssetKeyId(contract: ContractModel, collectionId: string): Promise<ResponseModel> {
        try {

            const data = {
                contract,
                collectionId
            };
            const response = await axios.put(
                CONTRACT_URL + "/assetkeyid",
                data,
                SandraJsAPI.getAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async updateBaseTokenUrl(contract: ContractModel, collectionId: string): Promise<ResponseModel> {
        try {

            const data = {
                contract,
                collectionId
            };
            const response = await axios.put(
                CONTRACT_URL + "/basetokenurl",
                data,
                SandraJsAPI.getAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async addProcess(type: string, chain: string, description: string) {
        {
            try {

                const data = {
                    id: chain + "_" + type,
                    chain,
                    description,
                };
                const response = await axios.post(
                    ADD_PROCESS,
                    data,
                    SandraJsAPI.getAuthHeader(),
                );
                return response.data;
            } catch (e) {
                console.error(e);
                throw e;
            }
        }

    }

    public static async getJetskiProcesses(): Promise<ResponseModel> {
        try {
            const response = await axios.get(GET_PROCESS_LIST,
                SandraJsAPI.getAuthHeader());
            let data = response.data;
            if (data?.data) {
                data.data = data.data.map((p: any) => {
                    return {
                        id: p.id,
                        processDescription: p.description,
                        blockchain: p.brothers?.onBlockchain,
                        status: p.pm2?.status != "online" ? "stopped" : "running",
                        monitor: p.pm2?.monitor,
                        processID: p.pm2?.pid,
                    }
                })
            }
            return data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getJetskiProcess(id: string): Promise<ResponseModel> {
        try {
            const response = await axios.get(GET_PROCESS_DETAILS + id,
                SandraJsAPI.getAuthHeader());
            let processes = response.data;
            if (processes?.data) {
                processes.data = {
                    id: processes.data.id,
                    processDescription: processes.data.description,
                    blockchain: processes.data.brothers?.onBlockchain,
                    processID: processes.data.pm2?.pid,
                    monitor: processes.data.pm2?.monitor,
                    status: processes.data.pm2?.status != "online" ? "stopped" : "running",
                    addresses: processes.data.contracts?.map((c: any) => {
                        let address = processes.data.joined?.find((j: any) => {
                            if ("has" in j) {
                                if (j.has.subjectId == c.subjectId)
                                    return true;
                            }
                            return false;
                        })
                        return {
                            hash: c.id,
                            standard: "",
                            status: address?.has?.refs?.status
                        }
                    })
                }
            }
            return processes;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async doProcessAction(id: string | string[], chain: string, phrase: string, action: string): Promise<any> {
        try {

            const data = {
                id,
                phrase,
                chain,
                action
            };
            const response = await axios.post(
                DO_PROCESS_ACTION,
                data,
                SandraJsAPI.getAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async addContractToProcess(processContract: ProcessContractModel, processId: string) {
        try {

            const data = {
                processId,
                contractId: processContract.hash,
                scan_details: {
                    status: processContract.status,
                    startBlock: processContract.startBlock,
                    endBlock: processContract.endBlock,
                    range: processContract.blockRange
                }
            };
            const response = await axios.post(
                ADD_PROCESS_CONTRACT,
                data,
                SandraJsAPI.getAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getContractAsync(id: string): Promise<ResponseModel> {
        try {

            const response = await axios.get(GET_CONTRACT_DETAILS + id,
                SandraJsAPI.getAuthHeader());

            let details = response.data?.data;

            if (details) {
                let inCollections: any[] = [];
                details?.joined?.forEach((d: any) => {
                    if ("inCollection" in d) {
                        inCollections.push(d.inCollection)
                    }
                });

                let standard = details?.joined?.find((d: any) => {
                    return (("contractStandard" in d) == true)
                });
                details.collections = inCollections;
                details.standard = (standard?.contractStandard?.class_name)?.replace("CsCannon\\Blockchains\\Contracts\\", "");
                details.address = details?.id;
                details.blockchain = details?.brothers?.onBlockchain;
                if (details?.process?.joined?.length > 0)
                    details.scan = {
                        ...details?.process?.joined[0].has?.refs,
                        hash: id,
                    };
                else
                    details.scan = {};

                details.scan.blockRange = details.scan?.range;
            }

            return response.data;

        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getProcessContractAsync(id: string): Promise<ResponseModel> {
        try {
            const response = await axios.get(GET_PROCESS_CONTRACT + id,
                SandraJsAPI.getAuthHeader());
            if (response.data?.data) {
                let details = {...response.data?.data};
                if (details?.joined?.length > 0)
                    response.data.data = details?.joined[0].has?.refs;
                response.data.data.id = details.id;
                response.data.data.hash = id;
                response.data.data.blockRange = response.data.data.range;
            }
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async updateProcessContract(processContract: ProcessContractModel, processId: string): Promise<ResponseModel> {
        try {
            try {
                const data = {
                    id: processId,
                    contractId: processContract.hash,
                    scan_details: {
                        status: processContract.status,
                        startBlock: processContract.startBlock,
                        endBlock: processContract.endBlock,
                        range: processContract.blockRange
                    }
                };
                const response = await axios.put(
                    UPDATE_PROCESS_CONTRACT,
                    data,
                    SandraJsAPI.getAuthHeader(),
                );
                return response.data;
            } catch (e) {
                console.error(e);
                throw e;
            }
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getContractStatuses(chain: string): Promise<any> {

        try {
            const response = await axios.get(GET_PROCESS_CONTRACT_STATUS + chain,
                SandraJsAPI.getAuthHeader());

            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }

    }

    public static async getRequestDBConfig(): Promise<any> {
        try {
            const response = await axios.get(GET_SERVER_CONFIG, SandraJsAPI.getProdAuthHeader());
            return response.data;
        } catch
            (e) {
            console.error(e);
            throw e;
        }

    }

    public static async getAsset(id: string): Promise<any> {
        try {
            const response = await axios.get(GET_ASSET + id, SandraJsAPI.getProdAuthHeader());
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getAssetsByQuery(filter: IAssetFilter, lastId: number | undefined, limit: number = 100): Promise<any> {
        try {
            const response = await axios.post(
                GET_ASSETS_BY_QUERY + "?lastId=" + lastId + "&limit=" + limit,
                filter,
                SandraJsAPI.getProdAuthHeader(),
            );

            return response.data;

        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getTokenBindings(token: string): Promise<any> {
        try {
            const response = await axios.get(GET_TOKEN_BINDINGS + token, SandraJsAPI.getProdAuthHeader());
            return response.data;

        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async getAssetBindingsByQuery(assetId: string): Promise<any> {
        try {

            const response = await axios.post(
                GET_ASSET_BINDINGS_BY_QUERY + "?assetId=" + assetId,
                {},
                SandraJsAPI.getProdAuthHeader(),
            );
            return response.data;

        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public static async saveExtendedAsset(id: string, json: string): Promise<any> {
        try {
            let jsonParsed: any = {};
            try {
                jsonParsed = JSON.parse(json);
            } catch (e) {
                throw new Error("Invalid JSON for extended asset, please verify your json.");
            }

            const data = {
                "id": id,
                "json": jsonParsed
            }

            const response = await axios.post(
                UPDATE_EXTENDED_ASSET,
                data,
                SandraJsAPI.getProdAuthHeader(),
            );
            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

}
